import styled from 'styled-components';

export const UserInfoContainer = styled.section`
  display: flex;
  column-gap: 0.6rem;
  align-items: center;
`;

export const UserName = styled.span`
  font-size: 1.4rem;
`;
